"use client";

import useSWR from "swr";
import useSWRMutation from "swr/mutation";

import { API_URLS } from "./constants";
import { fetcher } from "./utils";

export type GetScormProgressResponse = {
  payload: Record<string, unknown>,
  type: string,
  currentPercent: number,
  passPercent: number,
  error?: string,
};

export const useGetScormProgress = (params: {
  scormid: string,
  publicationid: string,
  unitid: string,
}, enabled: boolean = true) => {
  return useSWR<GetScormProgressResponse | null>(
    enabled ? [
      API_URLS.GET_SCORM_PROGRESS,
      params.scormid,
      params.publicationid,
      params.unitid,
    ] : null,
    async () => {
      return await fetcher<GetScormProgressResponse>({
        url: API_URLS.GET_SCORM_PROGRESS,
        method: "GET",
        params: {
          scorm: params.scormid,
          publicationid: params.publicationid,
          unitid: params.unitid,
        },
        stopAtKeys: [ "payload" ],
      });
    },
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
      keepPreviousData: false,
      dedupingInterval: 0,
      fallbackData: undefined,
      revalidateOnMount: true,
    },
  );
};

export type SetScormProgressRequest = {
  scorm: string,
  payload: Record<string, unknown>,
  type: string,
  progressMeasure: string,
  publicationid: string,
  unitid: string,
};

export type SetScormProgressResponse = {
  currentPercent?: number,
  passPercent?: number,
  type: string,
  error?: string,
};


export const useSetScormProgress = () => {
  return useSWRMutation(API_URLS.SET_SCORM_PROGRESS,
    async (_url, { arg }: { arg: SetScormProgressRequest }) => {
      const params: Record<string, string> = {
        scorm: arg.scorm,
        publicationid: arg.publicationid,
        unitid: arg.unitid,
        [ "progress_measure" ]: arg.progressMeasure,
        type: arg.type,
      };

      return await fetcher<SetScormProgressResponse>({
        url: API_URLS.SET_SCORM_PROGRESS,
        method: "POST",
        params,
        body: JSON.stringify({
          payload: arg.payload,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
    });
};
